import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';

import { createPinia } from 'pinia'

const pinia = createPinia()

// import Vuelidate from 'vuelidate'
import BootstrapVueNext from 'bootstrap-vue-next';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import "@/assets/scss/app.scss";

import { initFirebaseBackend } from './authUtils';

import 'emoji-picker-element'

import { configureFakeBackend } from './helpers/fake-backend';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_APIKEY,
    authDomain: process.env.VUE_APP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
    projectId: process.env.VUE_APP_PROJECTId,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APPId,
    measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
    initFirebaseBackend(firebaseConfig);
} else {
    // setup fake backend
    /**
     * process.env.VUE_APP_DEFAULT_AUTH === "fakebackend"
     */
    configureFakeBackend();
}


// import webSocket from '@/utils/webSocket博客园写法';
import storeVuex from './store/vuex' // 引入 Vuex store

import WebSocketPlugin from '@/utils/webSocket';

function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = "";
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    let data =  context == null || context == "" || context == "undefined" ? "" : context;
    console.clear()
    console.error("uid：",data)
    return data;
}

createApp(App)
    .use(storeVuex)
    .use(router)
    .use(i18n)
    .use(pinia)
    .use(BootstrapVueNext)
    .use(WebSocketPlugin,storeVuex,{ url: process.env.VUE_APP_WEBSOCKET_API,uid:GetQueryString('uid')||'' })
    .mount('#app');
